// Dedicated Vuex module for Coupe File (express checkout) state
// Each item: { tariffCode: String, quantity: Number, options: [{ tariffCode: String, quantity: Number }] }
export default {
  namespaced: true,

  state: () => ({
    isActive: false,
    items: [],
    guest: {
      email: '',
      postalCode: ''
    }
  }),

  getters: {
    isActive: state => state.isActive,
    items: state => state.items,
    totalQuantity: state => state.items.reduce((sum, item) => sum + item.quantity, 0),
    guest: state => state.guest
  },

  mutations: {
    setActive (state, value) {
      state.isActive = value;
    },

    setItemQuantity (state, { tariffCode, tariffCategoryCode, quantity }) {
      const existing = state.items.find(i => i.tariffCode === tariffCode);
      if (existing) {
        existing.quantity = quantity;
        if (quantity === 0) {
          state.items = state.items.filter(i => i.tariffCode !== tariffCode);
        }
      } else if (quantity > 0) {
        state.items.push({ tariffCode, tariffCategoryCode: tariffCategoryCode || null, quantity, options: [] });
      }
    },

    setItems (state, items) {
      state.items = items;
    },

    /** Set all options for a specific item (used for mandatory auto-selection) */
    setItemOptions (state, { tariffCode, options }) {
      const item = state.items.find(i => i.tariffCode === tariffCode);
      if (item) {
        item.options = options;
      }
    },

    /** Update a single option's quantity within an item */
    updateItemOptionQuantity (state, { itemTariffCode, optionTariffCode, tariffCategoryCode, horanetProductCode, quantity }) {
      const item = state.items.find(i => i.tariffCode === itemTariffCode);
      if (!item) return;

      const existing = item.options.find(o => o.tariffCode === optionTariffCode);
      if (existing) {
        existing.quantity = quantity;
      } else if (quantity > 0) {
        item.options.push({ tariffCode: optionTariffCode, tariffCategoryCode: tariffCategoryCode || null, horanetProductCode: horanetProductCode || null, quantity });
      }
      item.options = item.options.filter(o => o.quantity > 0);
    },

    clearItemOptions (state, tariffCode) {
      const item = state.items.find(i => i.tariffCode === tariffCode);
      if (item) {
        item.options = [];
      }
    },

    setGuest (state, { email, postalCode }) {
      if (email !== undefined) state.guest.email = email;
      if (postalCode !== undefined) state.guest.postalCode = postalCode;
    },

    reset (state) {
      state.isActive = false;
      state.items = [];
      state.guest = { email: '', postalCode: '' };
    }
  }
};
